"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16.4444 11C16.2084 11 16.0134 11.165 15.9604 11.394C15.7124 12.439 15.1864 13.433 14.3654 14.246C13.2214 15.38 11.7014 16.005 10.0844 16.005C8.15938 16.005 6.37138 15.12 5.19238 13.544C3.64238 11.472 3.64238 8.535 5.19138 6.462C6.36938 4.886 8.15838 4 10.0844 4C10.6144 4 11.1434 4.068 11.6534 4.204C12.6674 4.472 13.5984 5.005 14.3484 5.743L14.3744 5.77C14.4064 5.801 14.4274 5.839 14.4584 5.871L13.9484 6.378C13.8014 6.522 13.9014 6.786 14.0924 6.85L16.9284 7.301C17.2704 7.413 17.4564 7.229 17.3424 6.891L16.8874 4.079C16.8234 3.889 16.5634 3.785 16.4174 3.93L15.8914 4.451L15.8614 4.421C15.8364 4.396 15.8164 4.368 15.7924 4.344C15.7704 4.322 15.7464 4.307 15.7244 4.285L15.7094 4.271H15.7084C14.6844 3.284 13.4654 2.613 12.1744 2.271C11.4904 2.091 10.7874 2 10.0844 2C7.53938 2 4.99338 3.187 3.36438 5.559C1.54438 8.208 1.54538 11.8 3.36638 14.449C4.99538 16.819 7.54038 18.005 10.0844 18.005C12.1504 18.005 14.2154 17.224 15.7924 15.661C16.9614 14.502 17.6904 13.075 17.9904 11.58C18.0514 11.279 17.8024 11 17.4924 11H16.4444Z",
    fill: "#727B7F"
  }));
};